import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const galleryData = {
    "Luxe Heights": [
    "/luxe11.jpeg",
    "/luxe12.jpeg",
    "/luxe13.jpeg",
    "/luxe14.jpeg",
    "/luxe15.jpeg",
    "/luxe16.jpeg",
    "/luxe17.jpeg",
    "/luxe18.jpeg",
    "/luxe2.jpg",
    "/luxe3.jpg",
    "/luxe4.jpg",
    "/luxe5.jpg",
    "/luxe6.jpg",
    "/luxe7.jpg",
    "/luxe8.jpg",
    "/luxe9.jpg",
    "/luxe10.jpg",
    "/luxe19.jpeg",
    "/luxe20.jpeg",
    "/luxeheights.jpg",
  ],
  "Ezrah": [
    "/ezrah5.jpeg",
    "/ezrah6.jpeg",
   
    "/ezrah8.jpeg",
    "/ezrah9.jpeg",
    "/ezrah10.jpeg",
    "/ezrah11.jpeg",
    "/ezrah12.jpeg",
    "/ezrah13.jpeg",
    "/ezrah14.jpeg",
    "/ezrah15.jpeg",
    "/ezrah16.jpeg",
    "/ezrah17.jpeg",
    "/ezrah18.jpeg",
    "/ezrah.jpeg",
    "/ezrah1.jpeg",
    "/ezrah2.jpeg",
    "/ezrah3.jpeg",
    "/ezrah4.jpeg",

  ],
  "The Haven": [
    "/haven2.jpeg",
    "/haven3.jpeg",
    "/haven4.jpeg",
    "/haven5.jpeg",
    "/haven6.jpeg",
    "/haven7.jpeg",
    "/haven8.jpeg",
    "/haven9.jpeg",
    "/haven.jpeg",
    "/haven1.jpeg",
  ],
};

export default function GalleryPage() {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="bg-white">
      {/* Hero */}
      <section
        className="relative h-[50vh] bg-cover bg-center flex items-center justify-center"
        style={{ backgroundImage: "url('/luxeheights.jpg')" }}
      >
        <div className="absolute inset-0 bg-black/50" />
        <motion.div
          className="relative z-10 text-center text-white px-6"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4">
            Project Gallery
          </h1>
          <p className="text-lg max-w-2xl mx-auto">
            A visual journey from groundbreaking to completion of our signature
            developments.
          </p>
        </motion.div>
      </section>

      {/* Gallery Sections */}
      <div className="max-w-7xl mx-auto py-16 px-6 space-y-20">
        {Object.entries(galleryData).map(([property, images]) => (
          <div key={property}>
            <h2 className="text-2xl font-bold mb-6 text-gray-800">
              {property}
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {images.map((src, idx) => (
                <motion.img
                  key={idx}
                  src={src}
                  alt={`${property} ${idx + 1}`}
                  className="w-full h-64 object-cover rounded-xl shadow-lg cursor-pointer"
                  whileHover={{ scale: 1.05 }}
                  onClick={() => setSelectedImage(src)}
                />
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox Modal */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
          >
            <motion.img
              src={selectedImage}
              alt="Selected"
              className="max-h-[90vh] max-w-[90vw] rounded-xl shadow-xl"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
